<style lang="stylus">
@import '../cardMap.stylus';

span, .font20 {
  cursor: pointer;
}

.font20:hover {
  color: #00a28a;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>
<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search radius-5">
      <div class="map-title">
        <el-row>
          <CardHeader/>
          <el-col :span="12">
            <div class="t-r">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
              <SearchBtn/>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="font12 p-2 b1">
        <template v-if="userType">
          <span class="color2 pointer" @click="goBack(-2)">全国</span> >
          <span class="color2 pointer" @click="goBack(-1)">{{provinceName}}</span> >
          <span>{{cityName}}</span>
        </template>
        <template v-else>
          <span class="color2 pointer">全国</span> >
          <span class="color2 pointer" @click="goBack(-1)">{{provinceName}}</span> >
          <span>{{cityName}}</span>
        </template>
      </div>
    </div>
    <TotalCard :totalCount="totalCount"/>
    <Card v-for="(item,index) in cityItem" :key="index" :item="item" :titleType="false"/>
  </div>
</template>

<script>
import SearchBtn from '@/components/searchBtn'
import CardHeader from '../components/cardHeader.vue'
import Card from '../components/card'
import TotalCard from '../components/totalCard.vue'

import Cookies from 'js-cookie'
import http from '@/api/cardData'
import { hideExport } from '@/utils/tools'
export default {
  name: 'home',
  components: {
    CardHeader,
    SearchBtn,
    Card,
    TotalCard
  },
  data() {
    return {
      hideExport:hideExport,
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      cityCode: null,
      cityName: null,
      provinceName: null,
      totalCount: {},
      cityItem: [],
      mark: false,
      progressNum: 0
    }
  },
  created() {
    let cityCode = this.$route.query.cityCode
    let provinceName = this.$route.query.provinceName
    let cityName = this.$route.query.cityName
    this.provinceName = provinceName ? decodeURIComponent(provinceName) : null
    this.cityCode = cityCode ? decodeURIComponent(cityCode) : null
    this.cityName = cityName ? decodeURIComponent(cityName) : null
    this.initData()
  },
  watch: {
    timeSection: function(value, oldValue) {
      this.initData()
    },
    '$store.state.app.tab': function(value, oldValue) {
      this.initData()
    }
  },
  computed: {
    allTab() {
      return this.$store.state.app.tab
    },
    userType() {
      return this.$store.getters.userType != 2
    }
  },
  methods: {
    exportDate: function() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http[that.allTab].progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http[that.allTab].exportDataSite({
          start: that.timeSection[0], 
          end: that.timeSection[1],
          cityCode: that.cityCode,
          reqId
        })
      )
    },
    initNum: function(num) {
      num = format(num)+ ''
      if (num.indexOf('.') == -1) {
        return num
      }
      return num.split('.')[0]
    },
    format(num) {
          var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
              return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                  return $1+",";
                  });
          })
          return res;
    },
    initData: function() {
      let that = this
      let _option = {
        timeSection: [this.timeSection[0] * 1, this.timeSection[1] * 1],
        cityCode: this.cityCode
      }
      
      http[that.allTab].siteDate(_option).then(e => {
        let data = e.data
        that.totalCount = data.totalCount
        that.cityItem = data.cityItem
      })
    },
    goBack: function(num) {
      history.go(num)
    }
  }
}
</script>
